import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.803 2.018a.817.817 0 0 0-.22-.087c-.082-.02-.17-.03-.258-.03H5.408V.396c0-.106-.071-.207-.198-.281a.966.966 0 0 0-.479-.117H.768c-.09 0-.177.01-.26.03A.816.816 0 0 0 .29.115a.466.466 0 0 0-.147.129.263.263 0 0 0-.051.152v1.797a.243.243 0 0 0 0 .211V12.48c0 1.222.896 1.905 1.915 2.125v.981a.255.255 0 0 0 .043.157c.032.05.081.097.144.135.064.04.14.07.223.091a1.103 1.103 0 0 0 .532 0 .804.804 0 0 0 .223-.09.447.447 0 0 0 .145-.136.254.254 0 0 0 .043-.157v-.952c1.072-.187 2.048-.88 2.048-2.152V2.696h1.24l-.014 4.116c0 .052.017.104.05.152a.464.464 0 0 0 .147.13.816.816 0 0 0 .22.086c.081.02.17.03.258.03.18 0 .35-.042.477-.116.127-.074.198-.175.2-.28L7.998 2.3a.262.262 0 0 0-.051-.152.464.464 0 0 0-.147-.129M4.053 12.481c0 .938-.678 1.423-1.332 1.41h-.017c-.635-.022-1.262-.505-1.262-1.41V2.697h2.611v9.785Zm0-10.578h-2.61V.793h2.61v1.11Z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h8v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };